import { createAction, props } from '@ngrx/store';
import {LocationSetType} from '@emm/core/models/location-set-type.model';

export enum LocationSetTypesAction {
    Load = '[Menu Base Effects] Load Location Set Types',
    LoadSuccess = '[Menu API] Load Location Set Types Success',
    LoadFailure = '[Menu API] Load Location Set Types Failure',
    Select = '[Menu Filters] Select Location Set Type',
}

export const LocationSetTypesActions = {
    load: createAction(LocationSetTypesAction.Load),
    loadSuccess: createAction(LocationSetTypesAction.LoadSuccess, props<{ locationSetTypes: LocationSetType[] }>()),
    loadFailure: createAction(LocationSetTypesAction.LoadFailure, props<{ error: any }>()),
    select: createAction(LocationSetTypesAction.Select, props<{ tag: string }>())
};

export const AsyncActions = {
    loadActions: [LocationSetTypesActions.load],
    successActions: [LocationSetTypesActions.loadSuccess],
    errorActions: [LocationSetTypesActions.loadFailure]
};
